var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaggruppa159(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_159",
    "data-name": "Raggruppa 159",
    transform: "translate(-473 -539)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_12",
    "data-name": "Ellisse 12",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(473 539)",
    fill: "rgba(26,213,152,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_231",
    "data-name": "Tracciato 231",
    d: "M54.193,316.4l-3.17-3.189a1.282,1.282,0,0,1,0-1.8,1.264,1.264,0,0,1,1.793,0l2.273,2.286,6.075-6.113a1.264,1.264,0,0,1,1.793,0,1.281,1.281,0,0,1,0,1.8L55.985,316.4a1.263,1.263,0,0,1-1.792,0Z",
    transform: "translate(429 240)",
    fill: "#1ad598",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaggruppa159);
export default __webpack_public_path__ + "static/media/Raggruppa_159.bbad25741b45922c9f87376f6d09459b.svg";
export { ForwardRef as ReactComponent };